import { APP_COMPANY_COLOR } from "consts";

const LUMINANCE_WEIGHTS = [0.2126, 0.7152, 0.0722];

export const getContrastColor = (color: string = APP_COMPANY_COLOR): "black" | "white" => {
  let r: number, g: number, b: number;

  if (color.startsWith("#")) {
    const c = color.replace("#", "");
    r = parseInt(c.substring(0, 2), 16);
    g = parseInt(c.substring(2, 4), 16);
    b = parseInt(c.substring(4, 6), 16);
  } else {
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = 1;
    const ctx = canvas.getContext("2d")!;
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, 1, 1);
    const data = ctx.getImageData(0, 0, 1, 1).data;
    r = data[0];
    g = data[1];
    b = data[2];
  }

  const luminance = [r, g, b]
    .map((v) => {
      v /= 255;
      return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    })
    .reduce((acc, v, i) => acc + v * LUMINANCE_WEIGHTS[i], 0);

  // 0.179 is the default value, while 0.184 is a slightly adjusted threshold for better contrast in our specific color palette
  return luminance > 0.184 ? "black" : "white";
};
